import React from 'react';
import { withTranslation } from 'react-i18next';
import ClassName from 'classnames';

// styles
import './ycPerson.scss';

export const YcPerson = withTranslation('team')(
  class YcPersonClass extends React.PureComponent {
    render() {
      const { t, person } = this.props;
      const translatePath = `team.${person}`;

      return (
        <div className={ClassName(this.props.className, 'yc-person')}>
          <div className="yc-person__image">
            <img alt={t(`${translatePath}.fullName`)} src={`/images/c-team/${t(`${translatePath}.imageName`)}`} />
          </div>
          <div className="yc-person__text">
            <h3>
              <span className="fullname">{t(`${translatePath}.fullName`)}</span>
              <br />
              {t(`${translatePath}.role`)}
            </h3>
            <div
              className="presentation"
              dangerouslySetInnerHTML={{
                __html: t(`${translatePath}.presentation`),
              }}
            />
          </div>
        </div>
      );
    }
  },
);
